export const emptyStringToNull = (value: string, originalValue: string) =>
    originalValue === '' ? null : value;

export const removeSpaces = (value: string) => value.replace(' ', '');
